<template>
    <div>

        <!-- ##### Breadcumb Area Start ##### -->
        <section class="breadcumb-area bg-img d-flex align-items-center justify-content-center" style="background-image: url(images/landing_gallery.jpeg);">
        <!-- <div class="bradcumbContent">
            <h2>Reviews</h2>
        </div> -->
        </section>
        <!-- ##### Breadcumb Area End ##### -->

        <section class="gallery-block my-5" id="gallery">
            <!-- <div class="container fluid">
                <div class="d-flex flex-row" >
                    <div class="d-flex flex-column item" v-for="(pic, index) in picList" :key="index">
                        <a class="lightbox" v-for="p in pic" :href="p.fileDownloadUri">
                            <img class="img-fluid image" alt="" :src="p.fileDownloadUri">
                        </a>
                    </div>
                    
                </div>
            </div> -->
            <div class="container fluid">
                <div class="row">
                    <div v-for="(pic, index) in picList" :key="index" class="col-md-4" >
                        <div class="w-100 mb-4" :style="'background-image: url(\'https://www.malahini.mv:9443/web/api/picture/' + pic.ID + '\'); height: 200px; background-position: center; background-size: contain; background-repeat:no-repeat;'" data-toggle="modal" data-target="#exampleModal" @click="openModal(index)"></div>
                    <!-- <img :src="pic.fileDownloadUri" class="img-fluid rounded" data-toggle="modal" data-target="#exampleModal" @click="openModal(index)"> -->
                    </div>
                </div>
            </div>


            <!-- Modal -->
            <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" style="background-color: transparent;">
                    <div class="modal-header" style="border-bottom: none;">
                        <button type="button" class="close white-text" data-dismiss="modal" aria-label="Close" style="font-size: 2.5rem;" >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="padding: 0;">
                        
                        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                            <div class="carousel-inner">
                                <div class="carousel-item w-100 active" :style="'background-image: url(\'https://www.malahini.mv:9443/web/api/picture/' + firstPic.ID + '\'); height: 80vh; background-position: center; background-size: contain; background-repeat:no-repeat;'">
                                    <!-- <img class="d-block w-100" :src="firstPic.fileDownloadUri" alt="First slide" style="margin: 0;"> -->
                                </div>
                                <div class="carousel-item w-100" v-for="(pic, index) in picList" :key="index"  :style="'background-image: url(\'https://www.malahini.mv:9443/web/api/picture/' + pic.ID + '\'); height: 80vh; background-position: center; background-size: contain; background-repeat:no-repeat;'">
                                    <!-- <img class="d-block w-100" :src="pic.fileDownloadUri" alt="Second slide" style="margin: 0;"> -->
                                </div>
                                
                            </div>
                            <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>
                        </div>
                    </div>
                </div>
                </div>
            </div>

        </section>
        
    </div>
</template>
<script>
import {_} from 'vue-underscore';
import $ from 'jquery'
import 'bootstrap';
export default {
    name: "gallery",
    data: () => ({
        picList: [],
        firstPic: {}
    }),
    metaInfo: {
        title: 'Malahini Kuda Bandos - Gallery',
        meta: [
        { charset: 'utf-8' },
        { name: "description", content: "Malahini Kuda Bandos Gallery" },
        { name: "keywords", content: "Malahini,Kuda Bandos,gallery,pictures" }
        ]
    },
    mounted() {
        this.$http.get('https://www.malahini.mv:9443/web/api/picture/gallery').then((response)=>{
            let pics;
            pics = _.where(response.data, {ShowOnGallery: true}); // Get the sorted results
            this.firstPic = pics[0]
            this.picList = pics.shift()
            this.picList = _.sortBy(pics, 'PictureOrder')
        })
        
    },
    methods: {
        openModal(index) {
            $('#carouselExampleControls').carousel(index+1);
        }
    }
}
</script>